import { render, staticRenderFns } from "./TheJudicialWork.vue?vue&type=template&id=4fa604d6&"
import script from "./TheJudicialWork.vue?vue&type=script&lang=js&"
export * from "./TheJudicialWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports